<template>
  <div class="text-wrapper">
    <!-- 搜索项 -->
    <div class="search-wrapper flex">
      <div class="input-wrapper flex">
        <p>单位名称：</p>
        <el-input
          v-model="tableInfo.query.unitName"
          placeholder="请输入单位名称">
        </el-input>
      </div>
      <div class="btn-wrapper">
        <el-button type="primary" @click="getList">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>

    <div class="table">
      <div class="tab-wrapper flex">
        <el-tabs v-model="tabName" type="card" @tab-click="handleClickTab">
          <el-tab-pane
            v-for="item in tabList"
            :key="item.id"
            :label="item.classifyName"
            :name="item.id">
          </el-tab-pane>
        </el-tabs>
        <el-button class="set" type="primary" icon="el-icon-s-tools" @click="settingVisible = true">分类设置</el-button>
      </div>
      <el-button type="primary" @click="add">新建</el-button>
      <cooperator-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :query="tableInfo.query"
        :pager="true"
        :tab-index="true"
        :ind-label="labelName"
        :api="getCooperationList"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
      >
        <!-- 自定义列表内容 -->
        <template v-slot:col-unitName="scope">
          <p class="name">{{ scope.row.unitName }}</p>
        </template>
        <template v-slot:col-unitPropagateUrl="scope">
          <img
            :src="scope.row.unitPropagateUrl"
            v-if="scope.row.unitPropagateUrl"
            style="height:36px;"
            @click="handleShow(scope.row.unitPropagateUrl)">
          <span v-else> - </span>
        </template>
        <!-- 自定义列表内容 -->
        <template v-slot:col-state="scope">
          <p>{{ scope.row.state === 1 ? '已停用' : '已启用' }}</p>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-state="scope">
          <el-button
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.row.state === 2 ? '停用' : '启用' }}
          </el-button>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-delete="scope">
          <el-button
            v-if="scope.data.row.state === 1"
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
      </cooperator-table>
    </div>
    <setting-dialog
      ref="settingDialog"
      :setting-visible="settingVisible"
      @setting-close="settingVisible = false"
      @update-state="updateState">
    </setting-dialog>
    <cooperator-dialog
      ref="cooperatorDialog"
      :dialog-visible="dialogVisible"
      @close="dialogVisible = false"
      @submit="onSubmit">
    </cooperator-dialog>
    <preview :photo-shows="showPreview" :url="previewUrl" @showSrue="showPreview = false"></preview>
  </div>
</template>
<script>
import CooperatorTable from '@/components/PublicTable';
import SettingDialog from './components/settingDialog';
import CooperatorDialog from './components/cooperatorDialog';
import Preview from './components/preview';
import {
  getCooperationList,
  getClassifyList,
  addCooperationUnit,
  classifyUpdateState,
  delCooperationUnit,
  cooperatorUpdateState,
  updateCooperationUnit
  } from '@/api/api'
export default {
  components: {
    CooperatorTable,
    SettingDialog,
    CooperatorDialog,
    Preview
  },
  data() {
    return {
      labelName: '排序号',
      getCooperationList,
      dialogVisible: false,
      settingVisible: false,
      tabName: '',
      tabList: [],
      showPreview: false,
      previewUrl: '',
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        query: {
          classifyId: '',
          unitName: ''
        },
        fieldList: [
          { label: '单位名称', value: 'unitName', width: '140', type: 'slot'},
          { label: '单位宣传照片', value: 'unitPropagateUrl', type: 'slot' },
          { label: '状态', value: 'state', type: 'slot' }
        ],
        handle: {
          label: '操作',
          btList: [
            { label: '启用', type: 'text', event: 'state', show: true, slot: true },
            { label: '删除', type: 'text', event: 'delete', show: true, slot: true },
            { label: '编辑', type: 'text', event: 'edit', show: true },
          ]
        }
      }
    }
  },
  created() {
    this.getTabList();
  },
  methods: {
    handleShow(url) {
      this.showPreview = true;
      this.previewUrl = url;
    },
    add() {
      this.dialogVisible = true;
      this.$refs.cooperatorDialog.init({
        classifyId: this.tabName
      });
    },
    // 分类设置中的状态控制
    updateState(row) {
      classifyUpdateState({
        id: row.id
      }).then(res => {
        let { code, message } = res;
        if (code === 0) {
          this.$message.success(row.state === 1 ? '启用成功' : '停用成功');
          this.getTabList();
        } else {
          this.$message.error(message);
        }
      })
    },
    // 获取tab列表
    getTabList() {
      getClassifyList({
        limit: -1
      }).then(res => {
        let { code, data, message } = res;
        if (code === 0) {
          this.tabList = data;
          this.$refs.settingDialog.init(data);
          this.tabList.forEach(item => {
            if (item.state === 2) {
              this.tabName = item.id;
              this.tableInfo.query.classifyId = item.id;
            }
          })
          this.getList();
        } else {
          this.$message.error(message);
        }
      })
    },
    // tab切换
    handleClickTab(tab, event) {
      this.tabName = tab.name;
      this.tableInfo.query.classifyId = tab.name
      this.getList()
    },
    // 提交表单
    onSubmit(data) {
      if (data.isEdit) {
        updateCooperationUnit(data.form).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success('编辑成功');
            this.dialogVisible = false;
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      } else {
        addCooperationUnit(data.form).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success('保存成功');
            this.dialogVisible = false;
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      }
    },
    // 通过随机数请求列表
    getList() {
      this.tableInfo.refresh = Math.random();
    },
    // 重置
    reset() {
      this.tableInfo.query.unitName = '';
      this.getList();
    },
    // table操作
    handleClick(event, row) {
      if (event === 'edit') {
        this.$refs.cooperatorDialog.init(row);
        this.dialogVisible = true;
      } else if (event === 'state') {
        cooperatorUpdateState({
          id: row.id
        }).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success(row.state === 1 ? '启用成功' : '停用成功');
            this.getList();
          } else {
            this.$message.error(message);
          }
        })
      } else {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delCooperationUnit({
            id: row.id
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('删除成功');
              this.getList();
            } else {
              this.$message.error(message);
            }
          })
        });
      }
    },
    // table数据
    handleEvent(data) {
      this.tableInfo.data = data.records;
    },
  },
}
</script>
<style lang="scss" scoped>
.text-wrapper {
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;
  .flex {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .search-wrapper {
    width: 100%;
    .input-wrapper {
      .el-input {
        width: 200px;
        margin-left: 10px;
      }
    }
    .btn-wrapper {
      margin-left: 30px;
    }
  }
  .tab-wrapper {
    ::v-deep .el-tabs {
      &>.el-tabs__header {
        border-bottom: none;
      }
      .el-tabs__nav {
        border-color: #409EFF;
        .el-tabs__item {
          font-size: 13px;
          height: 35px;
          line-height: 35px;
          border-color: #409EFF;
          color: #409EFF;
          border-bottom: 1px solid #409EFF;
        }
        .is-active {
          color: #fff;
          background-color: #409EFF;
          border-color: #409EFF;
        }
      }
    }
    .set {
      margin-left: 20px;
    }
  }
  .name {
    width: 100px;
    overflow:hidden;
    text-overflow:ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2
  }

  .table {
    margin-top: 20px;
    .el-button {
      margin-bottom: 10px;
    }
  }
}
</style>